import { connect } from 'react-redux'
import SkipLink from '../components/SkipLink'

const mapStateToProps = state => ({
  strings: state.intl.messages.skipLink,
})

export default connect(mapStateToProps)(SkipLink)
